import React from 'react';
import { StarIcon, MessageSquareIcon, BellIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
const points = [{
  Icon: StarIcon,
  title: 'Asked for after every job',
  body: 'The request goes out automatically while the work is still fresh, so reviews stop being something you meant to get around to.'
}, {
  Icon: MessageSquareIcon,
  title: 'Answered from one place',
  body: 'Google, Yelp, Facebook, all in one inbox. Every review gets a reply, which is half of why people trust the ones they read.'
}, {
  Icon: BellIcon,
  title: 'You hear about a bad one first',
  body: 'An unhappy customer pings you before your next customer reads it. Most of the time it’s fixable if you catch it that day.'
}];
export function Reputation() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-489" data-mp="2w8wffdq766an">
      <Bloom size="lg" className="left-1/2 top-[-18rem] -translate-x-1/2" data-id="element-490" data-mp="309gb0cv4h1uo" />
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-491" data-mp="atsx433tbpzh">
        <SectionLabel data-id="element-492" data-mp="5vznf03awdug">Reputation management</SectionLabel>
        <h2 className="mt-8 max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-5xl" data-id="element-493" data-mp="5vhn9sdipfh9">
          Your reviews are the first thing anyone reads about you.
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-494" data-mp="fugmylgb20s4">
          People pick between you and the next company on the page before they ever call.
        </p>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-495" data-mp="3jbyq4fl4ujm7">
          {points.map(({
          Icon,
          title,
          body
        }) => <article key={title} className="rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d] p-8 transition-colors hover:border-emerald-500/40" data-id="element-496" data-mp="1vgwd898fbtb">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-500/10" data-id="element-497" data-mp="35hoacnr45zsa">
                <Icon className="h-5 w-5 text-emerald-500" aria-hidden="true" data-id="element-498" data-mp="30jw7iyoxkt9b" />
              </span>
              <h3 className="mt-6 text-lg font-semibold text-white" data-id="element-499" data-mp="3q81mnv35q7mk">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-500" data-mp="3u8ke3o151bo8">{body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}